import React from 'react'
import styled from 'styled-components'
import { routes } from '../App'
import { BackArrow } from '../styled/BackArrow'
import { HeaderText } from '../styled/HeaderText'
import { OnboardingHeader } from '../styled/OnboardingHeader'
import { SomeCTAButton } from '../styled/SomeCTAButton'

const SomeParagraph = styled.p`
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  margin: 16px;
  color: #525961;
`

export const MemberDashboardBillingUpdateSuccess: React.FC = ({
  history
}: any) => {
  return (
    <div className="App">
      <OnboardingHeader>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <BackArrow onClick={() => history.goBack()} />
          <HeaderText>Update Billing</HeaderText>
          <div style={{ width: '48px' }} />
        </div>
      </OnboardingHeader>
      <div style={{ padding: '16px' }}>
        <SomeParagraph>
          Successfully updated your billing information
        </SomeParagraph>
        <SomeCTAButton onClick={() => history.push(routes.memberDashboardHome)}>
          Home
        </SomeCTAButton>
      </div>
    </div>
  )
}
